import React, { Component } from 'react'
import Storage from './local-store';
export default function (ComposedComponent) {
  class jwt extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }
    // componentWillMount() {
      componentDidMount() {
      this.isvalidJWT();
    }

    componentDidMount() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    isvalidJWT() {
      let { id } = this.props.match.params;
      if (Storage.get('token') === null || Storage.get('token') === undefined) {
        if (id !== undefined && id === 'tv-display') {
        } else {
          this
            .props
            .history
            .push(`/`);

        }
      }
    }
    render() {
      return <ComposedComponent {...this.props} jwt={this.state} />
    }
  }
  return jwt;
}
